<template>
    <div id="user-group">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'User Group' },
            ]"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">User Group</h3>

        <v-card>
            <v-card-title>
                Daftar User Group
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createUsergroup()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    User Group
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="userGroups"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="false"
                :custom-pagination-total-items="userGroups.length"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editUserGroup()"
                v-on:changePage="pageNumber = $event"
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headers[$event.key] }
                "
            ></app-datatable>

            <app-spinner v-if="isLoading"></app-spinner>
        </v-card>
    </div>
</template>

<script>
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";

export default {
    name: "user-group",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            search: null,
            selectedRow: null,
            isLoading: false,
            userGroups: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Nama", value: "name" },
                { text: "Description", value: "description" },
                { text: "Konten Spesifik", value: "is_specific" },
            ],
        };
    },

    watch: {
        search() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData() {
            this.userGroups = [];
            var context = this;
            var search = null;
            context.isLoading = true;

            SalesService.getListUserGroup((result) => {
                if (result.success) {
                    this.pagination.totalPages = result.data.total_data;
                    result.data.user_groups.forEach((items, index) => {
                        var row = {
                            no: index,
                            id: items.id,
                            name: items.user_group_name,
                            description: items.description,
                            is_specific: items.is_specific,
                        };
                        context.userGroups.push(row);
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        type: "error",
                    });
                }
                context.isLoading = false;
            });
        },

        createUsergroup() {
            this.$router.push({ path: "/user-group/form" });
        },

        editUserGroup: function () {
            var userGroupId = this.selectedRow.id;
            this.$router.push({
                path: "/user-group/form",
                query: { id: userGroupId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// UserGroup.vue?bb4abcbc